import * as Enumerable from "linq";
import * as moment from "moment";
import { type MepPortTargetYears as MepPortTargetYear } from "../../../../../../../../models/mep/mep-emission-target-config.models";
import { MepLookupItem } from "../../../../../../../../models/mep/mep.models";
import { NotificationClientService, NotificationType } from "../../../../../../../../services/basics/notification-client.service";
import { MepEmissionTargetConfigService } from "../../../../../../../../services/mep/mep-emission-target-config.service";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { useView } from "aurelia-framework";

@useView('views/pages/modules/mep/tabs/mep-emission-targets/partials/mep-emission-targets-filters/mep-emission-targets-filters.html')
export class MepEmissionTargetsFilters {
    years: MepPortTargetYear[] = []; // this is to select the year for the configuration 
    baseYears: MepLookupItem[] = []; // this is used to set the base years for relative 
    loadingYears: boolean = false;
    portId: number;
    longTermYear: number = null;

    _selectedYear: MepPortTargetYear;

    @computedFrom(Reflection.getPropertyPath<MepEmissionTargetsFilters>(z=> z._selectedYear))
    get selectedYear() {
        return this._selectedYear;
    }
    set selectedYear(value: MepPortTargetYear) {
        if(value)
        {
            this._selectedYear = value;
            if (this.onSelectedYearChanged) {
                this.onSelectedYearChanged();
            }
        }
    }

    constructor(private mepEmissionTargetConfigService: MepEmissionTargetConfigService,
        private notificationClientService: NotificationClientService, portId: number,
        private onSelectedYearChanged: () => void) {
        this.portId = portId;
        this.onSelectedYearChanged = onSelectedYearChanged;

        this.initYears();
    }
    
    renderTargetsYearFunc = (item: MepPortTargetYear) => {
        if(item){
            return item.isLongTerm ? 'Long Term (FY ' + item.year + ')' : 'FY ' + item.year;
        }
        return '';
    };

    initYears(){
        //here do the api calls to load the data 
        this.loadingYears = true;
        this.mepEmissionTargetConfigService.getPortEmissionTargetInitData(this.portId, true)
            .then(response => {
                this._selectedYear = null;

                if (response.hasError) {
                    this.notificationClientService.show("MEP Targets", "Error retrieving the years for targets!", NotificationType.Error);
                } else {
                    this.years = response.targetYears;
                    this.baseYears = response.baseYears;

                    // let's also set the default one (THIS WILL trigger the loading of the emissions targets on Selected Year Changed)
                    if (this.years.length > 0) {
                        const currentYear = moment().year();
                        let year = Enumerable.from(this.years).firstOrDefault(x => x.year == currentYear);
                        if(!year)
                            year = this.years.filter(x => x.year < currentYear).length > 0?
                                Enumerable.from(this.years).orderByDescending(x => x.year).firstOrDefault(x => x.year < currentYear)
                                : this.years[0];
                        this.selectedYear = year;
                        const longTermYear = Enumerable.from(this.years).firstOrDefault(x => x.isLongTerm);
                        if (longTermYear) {
                            this.longTermYear = longTermYear.year;
                        }
                    }
                }

                this.loadingYears = false;
            }).catch(() => {
                this.notificationClientService.show("MEP Targets", "Error retrieving the years for targets!", NotificationType.Error);
                this.loadingYears = false;
            });
   }
}